import { LocationType } from 'constants/LocationType';
import { MeasurementType } from 'constants/MeasurementType';
import { TFunction } from 'i18next';
import { filter, get, isEmpty, toLower } from 'lodash';
import Measurer from 'models/Measurer';
import { Structure } from '../models/Structure';
import { handleUnit } from 'utils/UnitsConverter';

const MAINTENANCE_TYPES = [
  /*MeasurementType.BATTERY_PERCENT,*/
  MeasurementType.BATTERY,
  MeasurementType.KEEP_ALIVE,
];

const FILTERED_TYPES = [
    ...MAINTENANCE_TYPES,
  MeasurementType.WATER_LEVEL_ANALOG,
  MeasurementType.PRESSURE_ANALOG,
  MeasurementType.TEMPERATURE_ANALOG,
  MeasurementType.WATER_LEVEL,
];

export const generateFullName = (measurer: Measurer, t: TFunction): string => {
  return (
    generateRecursiveName(measurer) + ' > ' + getLabelFromMeasurer(measurer, t)
  );
};

export const generateStructureFullName = (
  structure: Structure,
  t: TFunction,
): string => {
  return generateRecursiveName(structure) + ' > ' + structure.locationName;
};

export const filterMaintenanceMeasurers = (measurerList: any) => {
  return filter(
    measurerList,
    (item) => !MAINTENANCE_TYPES.includes(item.measurementType),
  );
};

export const keepOnlyCalculators = (measurerList: any, isAdmin:boolean = false) => {
  const filterArray = [...FILTERED_TYPES];
  if(!isAdmin){
    filterArray.push(MeasurementType.WATER_HEIGHT)
  }

  return filter(
    measurerList,
    (item) => !filterArray.includes(item.measurementType),
  );
};

export const getLabelFromMeasurer = (measurer: Measurer, t: TFunction) => {
  const unitValue = handleUnit(measurer.measurementUnit);
  const unitStringValue = isEmpty(unitValue) ? '' :' ('+unitValue+')'
  if (!isEmpty(measurer.measurerLabel)) return measurer.measurerLabel + unitStringValue;
  return t(`measurementType.${toLower(get(measurer, 'measurementType', ''))}`)  + unitStringValue;
};

export const getFullLabelFromMeasurer = (measurer: Measurer, t: TFunction): string => {
  const location = get(measurer, 'device.location.locationName', '');
  const device = get(measurer, 'device.deviceName', '');
  const label = getLabelFromMeasurer(measurer, t);
  const parts = [location, device, label].filter(p => !isEmpty(p));
  return parts.join(' - ');
};

const generateRecursiveName = (value: any): string => {
  const parent: string | null = get(
    value,
    'parentLocation',
    get(value, 'location', get(value, 'device')),
  );
  let parentName: string = '';
  if (parent && get(parent, 'locationType') !== LocationType.COMPANY) {
    parentName = generateRecursiveName(parent);
    if (!isEmpty(parentName)) parentName += ' > ';
    return (
      parentName + get(parent, 'deviceName', get(parent, 'locationName', ''))
    );
  }
  return '';
};
